<div class="wrap">
  <h4>Modifier mes infos</h4>
  <ng-container *ngIf="!linkLicence">
    <form [formGroup]="updateUserForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="lastName">Nom</label>
        <input class="without_radio" type="text" formControlName="lastName" class="form-control"
          (input)="isInactive($event.target.value)" />
      </div>
      <div class="form-group">
        <label for="firstName">Prénom</label>
        <input class="without_radio" type="text" formControlName="firstName" class="form-control"
          (input)="isInactive($event.target.value)" />
      </div>
      <!-- <div class="form-group">
        <label for="dBirth">Date anniversaire</label>
        <input type="date" formControlName="dBirth" (input)="isInactive($event.target.value)">
      </div> -->
      <div class="form-group">
        <label for="email">E-mail</label>
        <input class="without_radio" type="email" formControlName="email" class="form-control"
          (input)="isInactive($event.target.value)" />
      </div>

      <div class="btn_action">
        <span (click)="goBack()">Retour</span>
        <button type="submit" [disabled]="loading" [ngClass]="{inactive: !inactive}">confirmer</button>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="linkLicence">
    <p>Pour toutes modifications de vos infos liées à votre compte, veuillez vous rapprocher de votre club à savoir :
    </p>
    <p class="my_club" (click)="showMyClub()">Mon Club <fa-icon [icon]="faLongArrowAltRight"></fa-icon>
    </p>
    <div class="btn_action">
      <button (click)="goBack()" class="btn_link">Retour </button>
    </div>
  </ng-container>
</div>